var exports = {
  "Qs": "x31de4314--66bee9--content",
  "DD": "x31de4314--66bee9--title",
  "Fp": "x31de4314--66bee9--link-container",
  "nf": "x31de4314--66bee9--link",
};

module.exports = exports;
